import styled from 'styled-components';

export const CellArea = styled.div`
  position: relative;
  height: 100%;
  padding: 0;
  color: inherit;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  &.selected {
    background-color: ${props => props.theme.adminSelectionColor};
    color: #ffffff;
  }

  &:hover {
    cursor: pointer;
  }

  &:focus {
    outline: none;
    background-color: ${props => props.theme.highlightColor};
    color: ${props => props.theme.hoverRowColor};
  }
`;

export const LabelWrap = styled.div`
  font-size: 16px;
  display: flex;
  justify-content: flex-start !important;
  align-items: center;

  p {
    margin: 0 0 0 1.25rem;
  }
`;

export const MenuOptions = styled.div`
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  border-radius: 0px 0px 5px 5px;
  background-color: ${props => props.theme.fieldBgColor};
  transition: all 0.5s ease-in-out;
  border-radius: 0 0 5px 5px;
  z-index: 500;
  width: 100%;
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1);
`;

export const DropDownOption = styled.div`
  position: relative;
  display: flex;
  background-color: ${props => props.theme.fieldBgColor};
  justify-content: flex-start;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  color: ${props => props.theme.textColor};
  line-height: 1rem;
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.highlightColor};
    color: ${props => props.theme.hoverRowColor};
  }

  &.highlighted {
    background-color: ${props => props.theme.highlightColor};
    color: ${props => props.theme.hoverRowColor};
  }
`;
